import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { SharedService } from 'src/app/common/services/shared.service';
import { AlertService } from 'src/app/common/components/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ReportService } from 'src/app/reports/services/report.service';
import { IReportEmbedConfiguration, models, } from 'powerbi-client';
import * as pbi from 'powerbi-client';
import { ReportMapService } from 'src/app/reports/services/report-map.service';
import { ActivatedRoute } from '@angular/router';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { layerConstant } from 'src/app/common/constants/layer-constant';
import { BiShowOnMapType } from '../bi-click-even-type.enum';

declare global {
  interface Window {
    DOWNLOAD_TOKEN?: string;
    SHOWONMAP_TOKEN?: string;
  }
}

const DOWNLOAD_TOKEN_VALUE = "dl-abc123"; // MUST match the Visual token For download request
const MESSAGE_SOURCE = 'powerbi-custom-visual';
const REQUEST_ACTION_DOWNLOAD = 'request-download';

const SHOWONMAP_TOKEN = "SOM-EST-123" // MUST match the Visual token For show on map request
const REQUEST_ACTION_SHOWONMAP = 'show-on-map';
const MESSAGE_SOURCE_SHOWONMAP = 'powerbi-custom-visual-showOnMap';


@Component({
  selector: 'app-power-bi-dynamic',
  templateUrl: './power-bi-dynamic.component.html',
  styleUrls: ['./power-bi-dynamic.component.scss']
})
export class PowerBiDynamicComponent implements OnInit, OnChanges, OnDestroy {

  @Input() params: any;

  // Subscriptions management
  private destroy$ = new Subject<void>();
  // UI State
  currentScroll = 0;
  visualLoader: boolean = false;
  overViewMenu: any = [];
  PowerBIData: any = {
    pb_container: []
  };
  embedData: any;
  catchmentCount: number = 0;

  powerbiService!: pbi.service.Service;
  powerBiReport: any;

  isFirstTime: boolean = true;

  currentReportView$: Subscription = new Subscription();
  currentReportView!: number;
  visualsMap = new Map<string, pbi.Embed>();

  constructor(
    private sharedService: SharedService,
    public translate: TranslateService,
    public reportService: ReportService,
    private mapService: ReportMapService,
    private route: ActivatedRoute,
    private alertService: AlertService
  ) {
    window.DOWNLOAD_TOKEN = DOWNLOAD_TOKEN_VALUE;
    window.SHOWONMAP_TOKEN = SHOWONMAP_TOKEN;
    this.initializeLanguageListener();
  }

  private initializeLanguageListener(): void {
    this.sharedService.language$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        if (this.PowerBIData?.pb_container?.length) {
          this.buildMenu();
        }
        if (lang && !this.isFirstTime) {
          this.applyFiltersToAll();
        }
      });
  }



  ngOnInit(): void {
    this.isFirstTime = false;

    this.powerbiService = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );

    if (this.reportService.getCurrentReport()?.powerbi_data) {
      this.PowerBIData = this.reportService.getCurrentReport().powerbi_data;
      this.PowerBIData.pb_container.sort(
        (a: any, b: any) => Number(a.sort_order) - Number(b.sort_order)
      );

      this.buildMenu();
      this.bootstrapVisuals();
      this.loadVisualReport();
    }

    this.currentReportView$ = this.reportService.reportView$.subscribe((view: number) => {
      if (this.currentReportView != view) {
        this.currentReportView = view;
        this.updateLayoutSetting();
      }
    });

    let polygon;
    this.route.queryParams.subscribe((param: any) => {
      if (param?.polygon) {
        polygon = param?.polygon;
      }
    });

    if (polygon) {
      this.getCatchmentCount(polygon);
    }





    window.addEventListener('message', async (event: any) => {
      try {
        const msg = event.data;
        // console.log('post data ',msg);

        if (!msg) return;

        if (msg.action == REQUEST_ACTION_DOWNLOAD || typeof msg.csv == 'string') {

          if (msg.source !== MESSAGE_SOURCE) {
            return;
          }
          // token check
          if (!msg.token || msg.token !== window.DOWNLOAD_TOKEN) {
            console.warn('[host] rejected download: invalid token', msg.token);
            return;
          }

          const filename = msg.filename || `visual-export-${new Date().toISOString().replace(/[:.]/g, '-')}.csv`;
          try {
            const blob = new Blob([msg.csv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(url);
            try { event.source.postMessage({ source: 'host', action: 'download-complete', success: true }, '*'); } catch (e) { }
          } catch (err) {
            console.error('[host] error saving csv', err);
            try { event.source.postMessage({ source: 'host', action: 'download-complete', success: false, error: String(err) }, '*'); } catch (e) { }
          }
        }
        if (msg.action == REQUEST_ACTION_SHOWONMAP) {

          if (msg?.source !== MESSAGE_SOURCE_SHOWONMAP) {
            console.warn('[host] rejected showonmap: invalid source', msg?.source);
            return;
          }
          // token check
          if (!msg.token || msg.token !== window.SHOWONMAP_TOKEN) {
            console.warn('[host] rejected showonmap: invalid token', msg.token);
            return;
          }
          // const mapValue = {
          //   "on_click":"property",
          //   "property_click": true,
          //   "is_layout": true,
          //   "lat": 29.37537196,
          //   "lon": 47.99140321,
          //   "property_name": "25Th February Tower",
          //   "property_uid": "LKWTAF3992"
          // }
          const mapValue = (msg.value && typeof msg.value[0] === 'string') ? JSON.parse(msg.value[0]) : null;
          if (mapValue && mapValue?.on_click == BiShowOnMapType.PROPERTY) {
            if (mapValue.property_click) {
              this.panToMap(mapValue, 'property_name', 'showOnMap', true, (mapValue?.is_layout == 1 ? true : false));
            } else {
              this.panToMap(mapValue, 'property_name', 'showOnMap');
            }
          } else if (mapValue && mapValue?.on_click == BiShowOnMapType.NEIGHBOURHOOD) {
            this.panToMap(mapValue, 'neigh_name', 'showOnMap');

          } else if (mapValue && mapValue?.on_click == BiShowOnMapType.PROJECT) {
            this.panToMap(mapValue, 'project_name', 'showOnMap');

          }
          // console.log(mapValue);

        }

      } catch (err) {
        console.error('[host] message handler top-level error', err);
      }
    }, false);

  }

  bootstrapVisuals(): void {
    for (const container of this.PowerBIData.pb_container) {
      for (const item of container.items) {
        const el = document.getElementById(`visualOne${item.visualId}`);
        if (!el) continue;

        this.powerbiService.bootstrap(el, { type: 'visual' });
      }
    }
  }

  buildMenu() {
    const langKey = this.sharedService.getCurrentLangID();

    this.overViewMenu = this.PowerBIData.pb_container
      .slice()
      .sort((a: any, b: any) => Number(a.sort_order) - Number(b.sort_order))
      .map((e: any) => ({
        label: e.label?.[langKey] ?? e.label?.['1'] ?? e.label,
        name: e.sort_order,
        count: null
      }));

    if (this.overViewMenu.length) {
      this.currentScroll = this.overViewMenu[0].name;

      setTimeout(() => {
        this.scrollPoint(this.currentScroll);
      }, 300);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['params'] && changes['params'].currentValue && !changes['params'].firstChange) {
      if (this.params?.polygon) {
        this.getCatchmentCount(this.params?.polygon);
      } else {
        this.applyFiltersToAll();
      }
    }
  }
  //Get Catchment for draw catchment
  getCatchmentCount(polygon: any) {
    let queryParams = { ...this.params };
    this.reportService.getCatchmentproperties(polygon, queryParams).subscribe((res: any) => {
      if (res.status === 200) {
        this.catchmentCount = res.data;
        this.applyFiltersToAll();
      }
    });
  }

  loadVisualReport(): void {
    this.visualLoader = true;

    this.reportService
      .powerBiFecthReport(
        this.PowerBIData.pb_group_id,
        this.PowerBIData.pb_report_id
      )
      .subscribe({
        next: res => {
          this.visualLoader = false
          this.embedData = res.data;
          this.embedVisualsPhased();
        },
        error: () => (this.visualLoader = false)
      });
  }

  async embedVisualsPhased(): Promise<void> {

    for (const container of this.PowerBIData.pb_container) {
      for (const item of container.items) {
        container['loader'] = true;
        const visualId = item.visualId;
        const el = document.getElementById(`visualOne${visualId}`);
        if (!el) continue;

        const config: pbi.IVisualEmbedConfiguration = {
          type: 'visual',
          id: this.PowerBIData.pb_report_id,
          embedUrl: this.embedData.embedUrl,
          tokenType: models.TokenType.Embed,
          accessToken: this.embedData.token,
          pageName: this.PowerBIData.pb_page_id,
          visualName: visualId,
          settings: {
            background: models.BackgroundType.Transparent,
            filterPaneEnabled: false,
            layoutType: models.LayoutType.Custom,
            customLayout: { displayOption: models.DisplayOption.FitToWidth },
            localeSettings: { language: this.translate.currentLang }
          }
        };

        let existing = this.getEmbeddedInstance(el);

        if (existing) {
          this.powerbiService.reset(el);
        }
        const visual = this.powerbiService.embed(el, config);
        this.visualsMap.set(visualId, visual);
        // this.visualLoader = false;
        visual.off('rendered');
        visual.off('error');
        visual.off('loaded');

        visual.on('loaded', async () => {

          // small delay prevents visualNotFound
          await new Promise(r => setTimeout(r, 150));

          await this.applyFilterToVisual(visual);

        })
        visual.on('rendered', async () => {
           container.loader = false;
        });

        visual.on('error', (err) => {
          console.error('Visual error:', err);
          container.loader = false;
        });
      }
    }
  }

  getEmbeddedInstance(el: HTMLElement) {
    try {
      return this.powerbiService.get(el);
    } catch {
      return null;
    }
  }
  updateLayoutSetting() {
    this.embedVisualsPhased();
  }

  async applyFilterToVisual(visual: any) {

    try {

      const basicFilter:any = await this.reportService.createFilterJson(this.params, this.catchmentCount);

      console.log('basic Filters ', basicFilter);

      await visual.setFilters(basicFilter);

      // const applied = await visual.getFilters();
      // console.log('Applied filters for visual', visual.config.visualName, applied);
    } catch (err) {
      console.warn('Filter error:', err);
    }
  }

  async applyFiltersToAll() {
    for (const visual of this.visualsMap.values()) {
      await this.applyFilterToVisual(visual);
    }
  }

  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }

  scrollPoint(menu: number) {
    setTimeout(() => {
      this.sharedService.scrollMenu(String(menu));
    }, 200);
  }

  async panToMap(
    value: any,
    columnName: any,
    type: string = '',
    isPropertyName: boolean = false,
    isFloorLayout: boolean = false,
    unit_layout: boolean = false) {

    this.reportService.reportView$.next(ReportsViewEnum.mapGridView);
    let layer_data = this.reportService.getCurrentReport();

    if (value?.lat && value?.lon && type != 'layout') {

      // click on neigh_name
      if (value.neigh_name && columnName == 'neigh_name') {
        let layerdat = layer_data?.map_layer?.filter((r: any) => r.layer_name == "neighbourhoods")[0];
        let zoom = 13
        if (layerdat) {
          layerdat.display = true;
          zoom = (Math.ceil((layerdat.maxZoom - layerdat.minZoom) / 2) + layerdat.minZoom);
        }
        this.mapService.overlay_mapLayer.next([layerdat]);
        this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: zoom, uid: value?.property_uid, layer_name: 'neighbourhood' });
      }

      // click on project_name
      if (value.project_name && columnName == 'project_name') {
        let layerdat = layer_data?.map_layer?.find((r: any) => r.layer_name == layerConstant.miprojects);
        let zoom = 16;
        if (layerdat) {
          layerdat.display = true;
          zoom = (Math.ceil((layerdat.maxZoom - layerdat.minZoom) / 2) + layerdat.minZoom);
        }
        this.mapService.overlay_mapLayer.next([layerdat]);
        value['proj_name'] = JSON.stringify(value?.project_label);
        this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: zoom, uid: value?.property_uid, layer_name: 'project', data: value, isNameClicked: isPropertyName, isFloorLayout, columnName: columnName });
      }

      // click on Property
      if (value?.property_uid && columnName == 'property_name') {
        try {
          let uid = value?.property_uid;
          const propertyData: any = await this.mapService.getParcelInfo(uid);
          if (propertyData.status == 200 && propertyData?.data?.length) {
            let properties = { ...propertyData.data[0], is_layout: value?.is_layout };
            this.mapService.mapCoordinates.next({ coordinates: [value.lat, value.lon], zoom: 18, uid: uid, layer_name: 'property', data: properties, isNameClicked: isPropertyName, isFloorLayout, columnName: columnName });
            if (isFloorLayout) this.showLayout(properties);
          } else {
            this.alertService.warn(this.translate.instant("reports.no_record_found"));
          }
        } catch (error) {
          this.alertService.warn("Something went Wrong!, Try Again");
        }
      }
    }
    if (type == 'showOnMap' && value?.tenants_lat_lon) {
      if (value?.shop_name) {
        this.reportService.retailInventoryTenantDetails(value.shop_name).subscribe((item: any) => {
          if (item.status == 200) {
            this.mapService.mapCoordinates.next({ data: item.data, multiLatLon: true, tenant_name: value?.tenant_name, zoom: 18 });
          } else { this.alertService.warn(this.translate.instant("reports.no_record_found")); };
        })
      } else {
        this.alertService.warn(this.translate.instant("reports.no_record_found"));
      }
      // this.mapService.mapCoordinates.next({coordinates:value?.tenants_lat_lon, multiLatLon: true, tenant_name: value?.tenant_name});
    }
    if (type == 'layout' && !unit_layout) {
      this.reportService.reportView$.next(ReportsViewEnum.mapGridView);
      this.showLayout(value, true)
    }
    if (type == 'layout' && unit_layout) {
      this.showTenant(value);
    }
  }

  showLayout(value: any, is_unit_layout?: boolean) {
    if (is_unit_layout) value['is_unit_layout'] = true;
    this.mapService.propertyinfotoggle.next(true);
    this.mapService.selected_propertydetails.next(value);
    this.reportService.showTenantMap$.next(value);
  }

  showTenant(value: any) {
    this.reportService.showUnitTenantMap$.next(value);
  }

  ngOnDestroy() {


    this.visualsMap.forEach((v: any) => {
      try {
        v.off();
        this.powerbiService.reset(v.element);
      } catch { }
    });

    this.visualsMap.clear();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
